const DEFAULT_TITLE = 'کیشوتو';

import Vue from "vue";
import App from "./App.vue";
import { routes } from "./router";
import vueRouter from "vue-router";
import GlobalComponents from "./utils/globalComponents";
import ApiServiceLayer from "@/api/apiServiceLayer";
import mixins from "./utils/mixins";
import store from "./store";
import "./utils/globalLibraries";

import { BootstrapVue } from 'bootstrap-vue'

import VueSweetalert2 from 'vue-sweetalert2';

import VueToast from 'vue-toast-notification';

//add najva
import './najva';

//add raychat
import './raychat';

/*import moment from 'vue-jalali-moment'

import PersianCalendar from 'vue-persian-calendar';*/
// Import Bootstrap an BootstrapVue CSS files (order is important)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

import 'vue2-animate/dist/vue2-animate.min.css';

import 'leaflet/dist/leaflet.css';


import {
  PATH
} from "@/utils/applicationPath";

import Store from "./store/index";


Vue.use(GlobalComponents);
Vue.use(vueRouter);
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2);
Vue.use(VueToast);

/*Vue.use(moment);
Vue.use(PersianCalendar);*/
Vue.use(require('vue-jalali-moment'));
Vue.use(require('vue-persian-calendar'))

Vue.prototype.$ApiServiceLayer = new ApiServiceLayer();
Vue.prototype.$Store = Store;
Vue.prototype.$PATH = PATH;


//Vue.prototype.$GlobalMethods = GlobalMethods;


Vue.config.productionTip = false;

const router = new vueRouter({
  routes,
  mode: "history",
});

Vue.filter('toPersianCurrency', function (value, symbol, decimals, options) {
  let separator;
  let digitsRE = /(\d{3})(?=\d)/g;
  let sign = value < 0 ? "-" : "";
  options = options || {};
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return "";
  symbol = symbol != null ? sign + " " + symbol : sign + " " + "تومان";
  decimals = decimals != null ? decimals : 2;
  separator = options.separator != null ? options.separator : ",";
  let stringified = Math.abs(value).toFixed(decimals);
  stringified = options.decimalSeparator
      ? stringified.replace(".", options.decimalSeparator)
      : stringified;
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  let i = _int.length % 3;
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? separator : "") : "";
  let _float = decimals ? stringified.slice(-1 - decimals) : "";
  symbol =
      "‫‫" +
      head +
      _int.slice(i).replace(digitsRE, "$1" + separator) +
      _float +
      symbol;
  return symbol;
})

router.beforeEach((to, from, next) => {
  let token = store.state.login.loginTempToken;
  console.log(to,from,next);

  if(to.path === "/live"){
    //alert("s");
    if (location.protocol === 'https:') {
      location.replace('http://kishoto.ir/live');
      console.log("https");
    }else if (window.location.href.indexOf('http://www') === 0){
      location.replace('http://kishoto.ir/live');
      console.log("www");
    }else{
      console.log("noting needed!");
    }
  }


  console.log(to.meta);
  console.log(to.meta.auth);

  if(to.meta.auth) {
    if (token) {
      if (to.path === "/login" || to.path === "/verify") {
        next("/profile");
      }
    }else{
      next("/login");
    }
  }

  next();
  /*if (token) {
    if (to.path === "/login") {
      next("/profile");
    }
    next();
  } else {
    if (to.path !== "/login") {
      next("/login");
    }
    next();
  }*/
});

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;

new Vue({
  mixins: [mixins],
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
